export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/locationBlackIcon.7cf4a8f8.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};